import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import './index.css';

// Public pages
import Home from './pages/Home';
import Classical from './pages/Classical';
import Retail from './pages/Retail';
import GemType from './pages/GemType';
import GemDetail from './pages/GemDetail';



export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/classical" element={<Classical />} />
          <Route path="/retail" element={<Retail />} />
          <Route path="/gems/:typeName" element={<GemType />} />
          <Route path="/gem/:id" element={<GemDetail />} />

         
          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}